import Tooltip from "@components/Tooltip";

const ProductLabel = ({ label }) => (
  <div className="inline-flex items-center w-full">
    <div className="inline-block text-14px border border-[#BC003B] rounded">
      <p className="leading-5 px-2 pb-0.5 text-[#BC003B] font-semibold">
        {label}
      </p>
    </div>

    <div className="ml-1.5">
      <Tooltip content="Acest produs are un pret competitiv in baza monitorizarilor interne zilnice" />
    </div>
  </div>
);

export default ProductLabel;
